import React from "react";
import { getImageSrc, isRegistered } from "./listing";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;

        return (
            <div>
                <h3>
                    <center><u>Biometric Details Report</u></center>
                </h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b>{searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b>{searchData.estate}</div>
                    <div className="col"><b>Division: </b>{searchData.division}</div>
                </div>
                <table className="display dataTable no-footer" style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Employee No</th>
                            <th>Name</th>
                            <th>Division</th>
                            <th style={{ textAlign: 'center' }}>Registered</th>
                            <th style={{ textAlign: 'center' }}>Image</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data != null && data.length > 0
                            ? data.map((item, index) => {
                                const src = getImageSrc(item.image);
                                return (
                                    <tr key={index} style={{ pageBreakInside: 'avoid' }}>
                                        <td>{item.employeeNo}</td>
                                        <td>{item.employeeName}</td>
                                        <td>{item.division}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            {isRegistered(item.isRegistered) ? 'Registered' : 'Not Registered'}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {src
                                                ? <img src={src} alt="" style={{ width: 50, height: 50, objectFit: 'cover' }} />
                                                : '-'}
                                        </td>
                                    </tr>
                                );
                            })
                            : null}
                    </tbody>
                </table>
            </div>
        );
    }
}